// MyContext.tsx
import React, { createContext, useState, PropsWithChildren } from "react";

type MyContextType = {
  onPage: string;
  setOnPage: React.Dispatch<React.SetStateAction<string>>;
};

const MyContext = createContext<MyContextType | undefined>(undefined);

const MyProvider: React.FC<PropsWithChildren<{}>> = ({ children }) => {
  const [onPage, setOnPage] = useState(window.location.pathname.substring(1));

  /* const onPageChange: React.Dispatch<React.SetStateAction<string>> = (
    newPage
  ) => {
    setOnPage(newPage);
  }; */

  return (
    <MyContext.Provider value={{ onPage, setOnPage }}>
      {children}
    </MyContext.Provider>
  );
};

export { MyContext, MyProvider };
